import { useTranslation } from "react-i18next";

import { Drawer } from "antd";
import { ActivityTab } from "../../../../components/activity-timeline/ActivityTab";
import { moduleSliceSelectors } from "../../../../redux/module/module.selector";
import { useAppSelector } from "../../../../redux/store";
import { useDrawersContext } from "../../../tasks/drawers-context";

export const ModuleDefinitionActivityDrawer: React.FC = () => {
  const { t } = useTranslation();
  const {
    moduleDefinitionActivityDrawerVisible,
    setModuleDefinitionActivityDrawerVisible,
  } = useDrawersContext();

  const selectedModuelDefinition = useAppSelector(
    moduleSliceSelectors.selectSelectedModuleDefinition,
  );

  if (!selectedModuelDefinition) {
    return null;
  }

  return (
    <Drawer
      title={t("common.activities")}
      onClose={() => setModuleDefinitionActivityDrawerVisible(false)}
      open={moduleDefinitionActivityDrawerVisible}
      size={"large"}
    >
      <ActivityTab entity={selectedModuelDefinition || {}} />
    </Drawer>
  );
};
